"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const constants = __importStar(require("@/common/constants"));
const paths_1 = require("@/common/app/paths");
const Board_vue_1 = __importDefault(require("@/client/components/Board.vue"));
const MoonBoard_vue_1 = __importDefault(require("@/client/components/moon/MoonBoard.vue"));
const PlanetaryTracks_vue_1 = __importDefault(require("@/client/components/pathfinders/PlanetaryTracks.vue"));
const LogPanel_vue_1 = __importDefault(require("@/client/components/logpanel/LogPanel.vue"));
const AppButton_vue_1 = __importDefault(require("@/client/components/common/AppButton.vue"));
const VictoryPointChart_vue_1 = __importDefault(require("@/client/components/gameend/VictoryPointChart.vue"));
const utils_1 = require("@/common/utils/utils");
const Timer_1 = require("@/common/Timer");
const CardType_1 = require("@/common/cards/CardType");
const ClientCardManifest_1 = require("@/client/cards/ClientCardManifest");
const GlobalParameter_1 = require("@/common/GlobalParameter");
const i18n_1 = require("@/client/directives/i18n");
const LogMessageDataType_1 = require("@/common/logs/LogMessageDataType");
function getViewModel(playerView, spectator) {
    if (playerView !== undefined)
        return playerView;
    if (spectator !== undefined)
        return spectator;
    throw new Error('Neither playerView nor spectator are defined');
}
exports.default = (0, vue_1.defineComponent)({
    name: 'game-end',
    props: {
        playerView: {
            type: Object,
            required: true,
        },
        spectator: {
            type: Object,
            required: true,
        },
    },
    computed: {
        viewModel() {
            return getViewModel(this.playerView, this.spectator);
        },
        game() {
            return getViewModel(this.playerView, this.spectator).game;
        },
        players() {
            return getViewModel(this.playerView, this.spectator).players;
        },
        color() {
            if (this.playerView !== undefined)
                return this.playerView.thisPlayer.color;
            if (this.spectator !== undefined)
                return this.spectator.color;
            throw new Error('Neither playerView nor spectator are defined');
        },
        downloadLogUrl() {
            const id = this.playerView?.id || this.spectator?.id;
            if (id === undefined) {
                return undefined;
            }
            return `${paths_1.paths.API_GAME_LOGS}?id=${id}&full=true`;
        },
        playersInPlace() {
            const copy = [...this.viewModel.players];
            copy.sort(function (a, b) {
                if (a.victoryPointsBreakdown.total < b.victoryPointsBreakdown.total)
                    return -1;
                if (a.victoryPointsBreakdown.total > b.victoryPointsBreakdown.total)
                    return 1;
                if (a.megacredits < b.megacredits)
                    return -1;
                if (a.megacredits > b.megacredits)
                    return 1;
                return 0;
            });
            return copy.reverse();
        },
        winners() {
            const sortedPlayers = this.playersInPlace;
            const firstWinner = sortedPlayers[0];
            const winners = [firstWinner];
            for (let i = 1; i < sortedPlayers.length; i++) {
                if (sortedPlayers[i].victoryPointsBreakdown.total === firstWinner.victoryPointsBreakdown.total &&
                    sortedPlayers[i].megacredits === firstWinner.megacredits) {
                    winners.push(sortedPlayers[i]);
                }
            }
            return winners;
        },
        isSoloGame() {
            return this.players.length === 1;
        },
        vpDataset() {
            return this.players.map((player) => {
                return {
                    label: player.name,
                    data: player.victoryPointsByGeneration,
                    color: player.color,
                };
            });
        },
        globalsDataset() {
            const dataset = [];
            const gpg = this.game.globalsPerGeneration;
            function getValues(param, min, max) {
                return gpg.map((entry) => {
                    const val = entry[param] ?? min;
                    return 100 * (val - min) / (max - min);
                });
            }
            dataset.push({ label: (0, i18n_1.$t)('Temperature'), color: 'red', data: getValues(GlobalParameter_1.GlobalParameter.TEMPERATURE, -30, 8) });
            dataset.push({ label: (0, i18n_1.$t)('Oxygen'), color: 'green', data: getValues(GlobalParameter_1.GlobalParameter.OXYGEN, 0, 14) });
            dataset.push({ label: (0, i18n_1.$t)('Oceans'), color: 'blue', data: getValues(GlobalParameter_1.GlobalParameter.OCEANS, 0, 9) });
            if (this.game.gameOptions.expansions.venus === true) {
                dataset.push({ label: (0, i18n_1.$t)('Venus'), color: 'yellow', data: getValues(GlobalParameter_1.GlobalParameter.VENUS, 0, 30) });
            }
            if (this.game.gameOptions.expansions.moon === true) {
                dataset.push({ label: (0, i18n_1.$t)('L. Habitat'), color: 'orange', data: getValues(GlobalParameter_1.GlobalParameter.MOON_HABITAT_RATE, 0, 8) });
                dataset.push({ label: (0, i18n_1.$t)('L. Mining'), color: 'pink', data: getValues(GlobalParameter_1.GlobalParameter.MOON_MINING_RATE, 0, 8) });
                dataset.push({ label: (0, i18n_1.$t)('L. Logistics'), color: 'purple', data: getValues(GlobalParameter_1.GlobalParameter.MOON_LOGISTICS_RATE, 0, 8) });
            }
            return dataset;
        },
        playerContributionsData() {
            return this.players.map((player) => {
                const steps = player.globalParameterSteps || {};
                const temp = steps[GlobalParameter_1.GlobalParameter.TEMPERATURE] || 0;
                const oxygen = steps[GlobalParameter_1.GlobalParameter.OXYGEN] || 0;
                const oceans = steps[GlobalParameter_1.GlobalParameter.OCEANS] || 0;
                const venus = steps[GlobalParameter_1.GlobalParameter.VENUS] || 0;
                const moonHabitat = steps[GlobalParameter_1.GlobalParameter.MOON_HABITAT_RATE] || 0;
                const moonMining = steps[GlobalParameter_1.GlobalParameter.MOON_MINING_RATE] || 0;
                const moonLogistics = steps[GlobalParameter_1.GlobalParameter.MOON_LOGISTICS_RATE] || 0;
                return {
                    player: player.name,
                    color: player.color,
                    temp,
                    oxygen,
                    oceans,
                    venus,
                    moonHabitat,
                    moonMining,
                    moonLogistics,
                    total: temp + oxygen + oceans + venus + moonHabitat + moonMining + moonLogistics,
                };
            });
        },
    },
    data() {
        return {
            constants,
        };
    },
    components: {
        'board': Board_vue_1.default,
        'log-panel': LogPanel_vue_1.default,
        AppButton: AppButton_vue_1.default,
        MoonBoard: MoonBoard_vue_1.default,
        PlanetaryTracks: PlanetaryTracks_vue_1.default,
        VictoryPointChart: VictoryPointChart_vue_1.default,
    },
    mounted() {
        document.title = `End of Game | ${constants.APP_NAME}`;
    },
    methods: {
        getEndGamePlayerRowColorClass(color) {
            return (0, utils_1.playerColorClass)(color, 'bg_transparent');
        },
        getTimer(p) {
            return Timer_1.Timer.toString(p.timer);
        },
        getCorporationName(p) {
            const cards = p.tableau;
            const corporationCards = cards
                .filter((card) => (0, ClientCardManifest_1.getCard)(card.name)?.type === CardType_1.CardType.CORPORATION)
                .map((card) => card.name);
            return corporationCards.length === 0 ? [''] : corporationCards;
        },
        translateMilestoneDetails(data) {
            const args = (data.messageArgs || []).map(i18n_1.$t);
            return (0, i18n_1.translateTextWithParams)(data.message, args);
        },
        translateAwardDetails(data) {
            if (!data.messageArgs || data.messageArgs.length < 3) {
                console.error(`Award detail has not enought data.
          It must contain at least 3 arguments:
          1) a Player's place in the race for the award
          2) translatable Award name
          3) not translatable Player name
          `);
                return this.translateMilestoneDetails(data);
            }
            const message = {
                message: data.message,
                data: [
                    {
                        type: LogMessageDataType_1.LogMessageDataType.STRING,
                        value: data.messageArgs[0],
                    },
                    {
                        type: LogMessageDataType_1.LogMessageDataType.AWARD,
                        value: data.messageArgs[1],
                    },
                    {
                        type: LogMessageDataType_1.LogMessageDataType.PLAYER,
                        value: data.messageArgs[2],
                    },
                ],
            };
            return (0, i18n_1.translateMessage)(message);
        },
    },
});
